/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetOwnClaimResponse } from './AssetOwnClaimResponse';
import {
    AssetOwnClaimResponseFromJSON,
    AssetOwnClaimResponseFromJSONTyped,
    AssetOwnClaimResponseToJSON,
    AssetOwnClaimResponseToJSONTyped,
} from './AssetOwnClaimResponse';

/**
 * 
 * @export
 * @interface AssetOwnClaimsTabResponse
 */
export interface AssetOwnClaimsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetOwnClaimsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetOwnClaimsTabResponse
     */
    hasOwnClaims: boolean | null;
    /**
     * 
     * @type {Array<AssetOwnClaimResponse>}
     * @memberof AssetOwnClaimsTabResponse
     */
    ownClaims: Array<AssetOwnClaimResponse>;
}

/**
 * Check if a given object implements the AssetOwnClaimsTabResponse interface.
 */
export function instanceOfAssetOwnClaimsTabResponse(value: object): value is AssetOwnClaimsTabResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('hasOwnClaims' in value) || value['hasOwnClaims'] === undefined) return false;
    if (!('ownClaims' in value) || value['ownClaims'] === undefined) return false;
    return true;
}

export function AssetOwnClaimsTabResponseFromJSON(json: any): AssetOwnClaimsTabResponse {
    return AssetOwnClaimsTabResponseFromJSONTyped(json, false);
}

export function AssetOwnClaimsTabResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetOwnClaimsTabResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'hasOwnClaims': json['hasOwnClaims'],
        'ownClaims': ((json['ownClaims'] as Array<any>).map(AssetOwnClaimResponseFromJSON)),
    };
}

export function AssetOwnClaimsTabResponseToJSON(json: any): AssetOwnClaimsTabResponse {
    return AssetOwnClaimsTabResponseToJSONTyped(json, false);
}

export function AssetOwnClaimsTabResponseToJSONTyped(value?: AssetOwnClaimsTabResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'hasOwnClaims': value['hasOwnClaims'],
        'ownClaims': ((value['ownClaims'] as Array<any>).map(AssetOwnClaimResponseToJSON)),
    };
}

